<template>
  <section class="vcenter">
    <form class="vcenter-form" @submit.prevent="submit">

      <h1>{{$t('password.title')}}</h1>

      <b-message v-if="errorMessage" type="is-danger">
        {{ errorMessage }}
      </b-message>

      <b-field :label="$t('password.field-password1')">
        <b-input v-model="password" type="password" />
      </b-field>

      <b-field :label="$t('password.field-password2')">
        <b-input v-model="password2" type="password" />
      </b-field>

      <div class="form-buttons">
        <button class="button is-primary" type="submit">{{$t('password.btn-valider')}}</button>
        <div class="right">
          <router-link class="small" to="/">{{$t('password.btn-back')}}</router-link>
        </div>
      </div>

      <b-loading :active="loading" :is-full-page="false" />
    </form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      password2: '',
      errorMessage: null,
      loading: false,
    }
  },
  methods: {
    async submit () {
      this.errorMessage = null
      if (this.password !== this.password2) {
        this.errorMessage = this.$t('password.error1')
        return
      }
      this.loading = true
      try {
        await this.$api.post('/login/password', {
          email: this.$route.query.email,
          token: this.$route.query.token,
          password: this.password,
        })
        this.$toast.open(this.$t('password.error2'))
        this.$router.push('/')
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          this.errorMessage = e.response.data.error
        } else {
          this.errorMessage = e.message || this.$t('password.error3')
        }
      }
      this.loading = false
    },
  }
}
</script>
